module.exports = __webpack_public_path__ + "static/media/figma-logo.3a444135.svg";